module.exports = __webpack_public_path__ + "static/media/plucky.e15ff6f9.mp3";